export default "__VITE_ASSET__2cd33b8d__"